<div class="main">
    <mat-form-field appearance="fill">
        <mat-label>Documenttype</mat-label>
        <select matNativeControl [(ngModel)]="documentType" (change)="updateDocumentType($event)" required>
            <ng-container *ngFor="let typeKey of optionKeys">
                <option [value]="typeKey">{{ options[typeKey].description }}</option>
            </ng-container>
        </select>
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>Brand</mat-label>
        <select matNativeControl [(ngModel)]="selectedOptions.branding" required>
            <option value="TO_BUILD">To Build</option>
            <option value="TO_BUILD_PROJECTS">Projects</option>
        </select>
    </mat-form-field>

    <div class="options">
        <div>Inclusief</div>
        <mat-slide-toggle [(ngModel)]="selectedOptions.includeTail">Staart</mat-slide-toggle><br>   
        <mat-slide-toggle [(ngModel)]="selectedOptions.includeTerms">Voorwaarden</mat-slide-toggle><br>   
        <!-- <mat-slide-toggle [(ngModel)]="selectedOptions.includeRemarks">Opmerkingen</mat-slide-toggle><br>    -->
        <mat-slide-toggle [(ngModel)]="selectedOptions.includeVat">BTW</mat-slide-toggle>
    </div>

    <mat-form-field appearance="fill">
        <mat-label>Paginagrootte</mat-label>
        <select matNativeControl [(ngModel)]="selectedOptions.paper.size"  required>
            <option value="a4">A4</option>
            <option value="a3">A3</option>
        </select>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Oriëntatie</mat-label>
        <select matNativeControl [(ngModel)]="selectedOptions.paper.orientation" required>
            <option value="PORTRAIT">Staand</option>
            <option value="LANDSCAPE">Liggend</option>
        </select>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Taal</mat-label>
        <select matNativeControl [(ngModel)]="selectedOptions.language" required>
            <option value="nl">Nederlands</option>
            <option value="en">Engels</option>
        </select>
    </mat-form-field>

    <button mat-raised-button (click)="exportPdf()">Exporteer PDF</button>

</div>